module.exports = __webpack_public_path__ + "img/solarroof_mob@2x.5a3e544.webp";